import { usePrice } from "../../contexts/PriceCtx";
import { priceServices } from "../../services/priceServices";
import { IoPencilSharp, IoCloseSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { Table, Button, Input } from "antd";
import { Notification } from "../../utils/Notification";

const Price = () => {
  const { price, setPrice } = usePrice();
  const navigate = useNavigate();
  const { Search } = Input;

  const columns = [
    {
      title: "Д/д",
      dataIndex: "priceId",
      key: "priceId",
    },
    {
      title: "Эхлэх үнэ",
      dataIndex: "priceBegin",
      key: "priceBegin",
    },
    {
      title: "Дуусах үнэ",
      dataIndex: "priceEnd",
      key: "priceEnd",
    },
    {
      title: "Засах",
      key: "key",
      dataIndex: "key",
      render: (text, record) => (
        <Button
          onClick={() => handlerEditBtn(record)}
          style={{ border: "none" }}
        >
          <IoPencilSharp />
        </Button>
      ),
    },
    {
      title: "Устгах",
      key: "key",
      dataIndex: "key",
      render: (text, record) => (
        <Button
          onClick={() => handlerDltBtn(record)}
          style={{ border: "none" }}
        >
          <IoCloseSharp />
        </Button>
      ),
    },
  ];
  function handlerAddBtn() {
    navigate("/price/create");
  }
  function handlerEditBtn(e) {
    navigate(`/price/${e.priceId}`);
  }
  function handlerDltBtn(e) {
    priceServices
      .getPriceDlt(e.priceId)
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          Notification.openNotification("topRight", "success", result.msg);
          priceServices
            .getAllPrice()
            .then((response) => response.json())
            .then((result) => {
              if (result.success === true) {
                setPrice(
                  result?.data.map((row, i) => ({
                    priceId: row.priceId,
                    priceBegin: row.priceBegin,
                    priceEnd: row.priceEnd,
                    key: i,
                  }))
                );
              }
            });
        }
      });
  }
  function onSearch(e) {
    priceServices
      .getSearchPrice(e)
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          setPrice(
            result?.data.map((row, i) => ({
              priceId: row.priceId,
              priceBegin: row.priceBegin,
              priceEnd: row.priceEnd,
              key: i,
            }))
          );
        }
      });
  }

  return (
    <div className="w-full h-full">
      <div className="flex">
        <Button
          className="bg-[#1677ff] text-[#fff] mb-3"
          onClick={handlerAddBtn}
        >
          Үнэ нэмэх
        </Button>
        <Search
          placeholder="input search text"
          onSearch={onSearch}
          className="w-full ml-5"
        />
      </div>
      <Table dataSource={price} columns={columns} />
    </div>
  );
};
export default Price;
